import { render, staticRenderFns } from "./ReturnabilityByStaffSubHeader.vue?vue&type=template&id=50100bc7&scoped=true"
import script from "./ReturnabilityByStaffSubHeader.vue?vue&type=script&lang=js"
export * from "./ReturnabilityByStaffSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50100bc7",
  null
  
)

export default component.exports